import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from "../components/SEO";
import Consultation from '../pages/Consultation'; 
import renovaImg from "../assets/images/projects/Renova.png"; 
import ccsharoffImg from "../assets/images/projects/Ccshroff.png"; 
import NeelimaImg from "../assets/images/projects/Neelima.png";
import AmericaImg from "../assets/images/projects/America.png";
import SriharinyaImg from "../assets/images/projects/Sriharinya.png";
import AmviImg from "../assets/images/projects/Amvi.png";
import PadmajaImg from "../assets/images/projects/Padmaja.png";
import KiranImg from "../assets/images/projects/Kiran.png";
import MedistarImg from "../assets/images/projects/Medistar.png";
import BhrungiImg from "../assets/images/projects/Bhrungi.png";
import SunriseImg from "../assets/images/projects/Sunrise.png";
import SaiSiddharthaImg from "../assets/images/projects/SaiSiddhartha.png";
import SiddharthaImg from "../assets/images/projects/Siddhartha.png";
import VinodImg from "../assets/images/projects/vinod-hospital.png";
import PbrImg from "../assets/images/projects/pbr-hospital.png";
import MmsImg from "../assets/images/projects/mms-hospital.png";
import MiracleImg from "../assets/images/projects/miracle-hospital.png";
import MedistarHospitalImg from "../assets/images/projects/medistar-hospital.png";
import jalapathyImg from "../assets/images/projects/jalapathi-hospital.png";
import PaarthivImg from "../assets/images/projects/Paarthiv.png";
import CitineroImg from "../assets/images/projects/Citineuro.png";
import SreevedaImg from "../assets/images/projects/Sreeveda.png";
import SamuelImg from "../assets/images/projects/Samuel.png";
import DhruvaImg from "../assets/images/projects/Dhruva.png";
import SamyukthaImg from "../assets/images/projects/Samyuktha.png";
import LimsImg from "../assets/images/projects/Lims.png";
import ShreyaImg from "../assets/images/projects/Shreya.png";
import ZaibynImg from "../assets/images/projects/Zaibyn.png";
import OneCardiacImg from "../assets/images/projects/Onecardic.png";
import VijayaImg from "../assets/images/projects/Vijaya.png";
import RncImg from "../assets/images/projects/Rnc.png";
import AlphaImg from "../assets/images/projects/Alpha.png";
import LotusImg from "../assets/images/projects/Lotus.png";
import RemedyImg from "../assets/images/projects/Remedy.png";
import LalithaImg from "../assets/images/projects/Lalitha.png";
import HarithaImg from "../assets/images/projects/Haritha.png";
import VarmaImg from "../assets/images/projects/Varma.png";
const PAGE_SIZE = 9;

const RAW_HOSPITALS = [
  { name: "Renova Neelima Hospital (A & B Blocks)", locality: "Sanath Nagar", city: "Hyderabad", type: "Multi-Specialty", img: renovaImg, mapsUrl: "https://maps.app.goo.gl/xMAE2tBFgkQCRCFb7" },
  { name: "Neelima Hospital", locality: "Moti Nagar", city: "Hyderabad", type: "Multi-Specialty", img: NeelimaImg, mapsUrl: "https://maps.app.goo.gl/T8dDbkv4xf3GXtF473" },
  { name: "CC Sharoff Hospital", locality: "Kachiguda", city: "Hyderabad", type: "Multi-Specialty", img: ccsharoffImg, mapsUrl: "https://maps.app.goo.gl/LDkcaFaR9wAS6icx5" },
  { name: "Premier American Kidney Institute", locality: "", city: "Vijayawada", type: "Kidney & Dialysis", img: AmericaImg, mapsUrl: "https://maps.app.goo.gl/3LHzhWDWrrFGEB677" },
  { name: "Sri Harinya Hospital", locality: "Beeramguda", city: "Hyderabad", type: "Multi-Specialty", img: SriharinyaImg, mapsUrl: "https://maps.app.goo.gl/qTV6HHogGRxQTjM4A" },
  { name: "AMVI Hospital", locality: "Puppalaguda", city: "Hyderabad", type: "Multi-Specialty", img: AmviImg, mapsUrl: "https://maps.app.goo.gl/tZsMKGVUa6Ah8ENe8" },
  { name: "Padmaja Hospital", locality: "", city: "Narsapur", type: "Multi-Specialty", img: PadmajaImg, mapsUrl: "https://maps.app.goo.gl/feYJWYCXJE7A7i9LA" },
  { name: "Kiran Hospital", locality: "Karmanghat", city: "Hyderabad", type: "Multi-Specialty", img: KiranImg, mapsUrl: "https://maps.app.goo.gl/TuLMYqCy1zamPiP58" },
  { name: "Varma Hospital", locality: "", city: "Rajahmundry", type: "Multi-Specialty", img: VarmaImg, mapsUrl: "https://maps.app.goo.gl/oLcmJczoCV8WkGtT8" },
  { name: "Bhrungi Hospital", locality: "M.N. Reddy Nagar", city: "Hyderabad", type: "Multi-Specialty", img: BhrungiImg, mapsUrl: "https://maps.app.goo.gl/YuRtKAyCJxWPVFUB9" },
  { name: "Sunrise Hospital", locality: "Shamshabad", city: "Hyderabad", type: "Multi-Specialty", img: SunriseImg, mapsUrl: "https://maps.app.goo.gl/Etzi3rLb3DghhJx56" },
  { name: "Sai Siddhartha Hospital", locality: "Shapur", city: "Hyderabad", type: "Multi-Specialty", img: SaiSiddharthaImg, mapsUrl: "https://maps.app.goo.gl/7uoAAFhgPTJvjbnEA" },
  { name: "Siddarth Neuro Hospital", locality: "Madinaguda", city: "Hyderabad", type: "Neuro", img: SiddharthaImg , mapsUrl: "https://maps.app.goo.gl/9uS2bhM4hKS7m4jB9" },
  { name: "Citi Neuro Hospital", locality: "Miyapur", city: "Hyderabad", type: "Neuro", img: CitineroImg, mapsUrl: "https://maps.app.goo.gl/qkkG3thhYHegG2gB9" },
  { name: "Paarthiv Lung Care", locality: "Sanath Nagar", city: "Hyderabad", type: "Lung Care", img:PaarthivImg,mapsUrl: "https://maps.app.goo.gl/9f32TNRTR2zS7PtB6" },
  { name: "Vinod Hospital", locality: "", city: "Sangareddy", type: "Multi-Specialty", img: VinodImg, mapsUrl: "https://maps.app.goo.gl/pkt6nkevtFPHUoxAA" },
  { name: "Sri Chakra Hospital", locality: "", city: "Sangareddy", type: "Multi-Specialty", mapsUrl: "" },
  { name: "Dhruva Hospital", locality: "Isnapur", city: "Hyderabad", type: "Multi-Specialty", img:DhruvaImg, mapsUrl: "https://maps.app.goo.gl/c85s8x9ZpUCAQtWD7" },
  { name: "Panacea Hospital (B Block)", locality: "RC Puram", city: "Hyderabad", type: "Multi-Specialty", mapsUrl: "https://maps.app.goo.gl/Yi6KctY1burxeyuq6" },
  { name: "Sree Veda Multi Speciality", locality: "Beeramguda", city: "Hyderabad", type: "Multi-Specialty",img:SreevedaImg, mapsUrl: "https://maps.app.goo.gl/CsFHHyG49xHoA8Q76" },
  { name: "One Cardiac Multi Speciality", locality: "Chanda Nagar", city: "Hyderabad", type: "Cardiac", img: OneCardiacImg, mapsUrl: "https://maps.app.goo.gl/ec2ptMg8MxYTjevf8" },
  { name: "Zaybin Hospital", locality: "Charminar", city: "Hyderabad", type: "Multi-Specialty", img:ZaibynImg, mapsUrl: "https://maps.app.goo.gl/KQH9oJoDR61JhgKd6" },
  { name: "Shreya Hospital", locality: "Moti Nagar", city: "Hyderabad", type: "Multi-Specialty", img:ShreyaImg,mapsUrl: "https://maps.app.goo.gl/9iefdvdRb4kFLhEF6" },
  { name: "RNC Hospital (B & C Blocks)", locality: "Chintal", city: "Hyderabad", type: "Multi-Specialty",img:RncImg, mapsUrl: "https://maps.app.goo.gl/rwNLp7iZtFSGZ9bq7" },
  { name: "Samyukta Children's Hospital", locality: "Hayathnagar", city: "Hyderabad", type: "Paediatric", img:SamyukthaImg, mapsUrl: "https://maps.app.goo.gl/suH5ZHun5LMVmMfX8" },
  { name: "Miracle Hospital", locality: "Uppal", city: "Hyderabad", type: "Multi-Specialty",img:MiracleImg, mapsUrl: "https://maps.app.goo.gl/jbmJsvNgW7FCtnwX6" },
  { name: "Jalapathy Reddy Hospital", locality: "Vanasthalipuram", city: "Hyderabad", type: "Multi-Specialty", img: jalapathyImg, mapsUrl: "https://maps.app.goo.gl/YQnep59iVqrxvUo57" },
  { name: "PBR Multi Speciality Hospital", locality: "IDA Bollarum", city: "Hyderabad", type: "Multi-Specialty",img:PbrImg, mapsUrl: "https://maps.app.goo.gl/j3pr55igd8eVu4Ap7" },
  { name: "Alpha Health City Hospital", locality: "Anathapur", city: "Hyderabad", type: "Multi-Specialty",img:AlphaImg, mapsUrl: "https://maps.app.goo.gl/wv5CuEUBCCFa4het9" },
  { name: "Lalitha Hospital", locality: "Jagadgirigutta", city: "Hyderabad", type: "Multi-Specialty",img:
LalithaImg,  mapsUrl: null },
  { name: "Vijaya Super Speciality Hospital", locality: "Pedda Amberpet", city: "Hyderabad", type: "Super Speciality",img:VijayaImg, mapsUrl: "https://maps.app.goo.gl/qwBgwf9mg16dthnK8" },
  { name: "Lotus Hospital", locality: "", city: "Jangaon", type: "Multi-Specialty", img:LotusImg, mapsUrl: "https://maps.app.goo.gl/7849Y2HTh3JjSyWDA" },
  { name: "Remedy Cardiac Hospital", locality: "Kukatpally", city: "Hyderabad", type: "Cardiac", img:RemedyImg, mapsUrl: "https://maps.app.goo.gl/9ntMqM8D19VCx4297" },
  { name: "Samuel Super Speciality Hospital", locality: "", city: "Mahabubnagar", type: "Super Speciality", img: SamuelImg, mapsUrl: "https://maps.app.goo.gl/GiT979MveNMjmJvU7" },
  { name: "Medistar", locality: "Maitrivanam", city: "Hyderabad", type: "Multi-Specialty",img:MedistarHospitalImg, mapsUrl: "https://maps.app.goo.gl/b8xnRCryNr5MZWTr8" },
  { name: "MMS Hospital", locality: "LB Nagar", city: "Hyderabad", type: "Multi-Specialty", img:MmsImg,mapsUrl: "https://maps.app.goo.gl/38tvucfqKXsiKRQ59" },
  { name: "Medistar Hospital", locality: "", city: "Indresham", type: "Multi-Specialty", img: MedistarImg, mapsUrl: "https://maps.app.goo.gl/7MnvstxRKGzjqFVDA" },
  { name: "Murugan Hospital", locality: "Punjagutta", city: "Hyderabad", type: "Multi-Specialty", mapsUrl: "https://maps.app.goo.gl/ddmYLsFQfBXdn9K59" },
  { name: "Dolphin Hospital", locality: "", city: "Bhuvanagiri", type: "Multi-Specialty", mapsUrl: null },
  { name: "Teja Kidney Care", locality: "Khairatabad", city: "Hyderabad", type: "Kidney & Dialysis", mapsUrl: "https://maps.app.goo.gl/dc4NL1UqSPsGo6RB7" },
  { name: "Haritha Mother & Child", locality: "", city: "Khammam", type: "Mother & Child", img: HarithaImg, mapsUrl: "https://maps.app.goo.gl/9Kin2tBWmgk9SnxJ8" },
  { name: "LIMS Hospital (Façade)", locality: "Shamshabad", city: "Hyderabad", type: "Façade / Elevation",img:LimsImg, mapsUrl: "https://maps.app.goo.gl/4FmH2Fu7JWN4T7eT8" },
];

// A muted, monochrome-leaning palette so placeholders feel like part of
// the site rather than random colour noise. Cycles by index.
const PLACEHOLDER_COLORS = [
  "#262E63", "#3A4060", "#3A4060", "#343F86", "#5B6072",
  "#262E63", "#3A4060", "#262E63", "#3A4060", "#3A4060",
];

function slugify(str) {
  return str
    .toLowerCase()
    .replace(/[().]/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function initialsOf(str) {
  const words = str.replace(/\(.*?\)/g, "").trim().split(/\s+/).filter(Boolean);
  const skip = new Set(["hospital", "hospitals", "&", "of", "the"]);
  const letters = words.filter(w => !skip.has(w.toLowerCase())).slice(0, 2).map(w => w[0]);
  return (letters.join("") || str[0] || "?").toUpperCase();
}

const ALL_PROJECTS = RAW_HOSPITALS.map((h, i) => {
  const { name, locality, city, type, img, mapsUrl } = h;
  const location = locality ? `${locality}, ${city}` : city;
  return {
    id: i + 1,
    title: name,
    slug: slugify(name),
    locality,
    city,
    location,
    type,
    address: `${name}, ${location}`,
    mapsUrl: mapsUrl || null,
    img: img || null, // set per-hospital once a real photo is available
    initials: initialsOf(name),
    placeholderColor: PLACEHOLDER_COLORS[i % PLACEHOLDER_COLORS.length],
  };
});

const CITIES = ["All", ...Array.from(new Set(ALL_PROJECTS.map(p => p.city))).sort()];
const TYPES  = ["All", ...Array.from(new Set(ALL_PROJECTS.map(p => p.type))).sort()];

/* A simple illustrated hospital building — used instead of a photo when
   no real photo is available yet. Windows are punched out in the card's
   own placeholder colour so it reads as "lit windows" against the light
   building silhouette, with a small medical-cross badge on the facade. */
function HospitalBuildingIcon({ bg }) {
  const win = (x, y) => <rect x={x} y={y} width={6} height={8} rx={1} fill={bg} />;
  return (
    <svg viewBox="0 0 120 100" width="56%" height="56%" style={{ maxWidth: 110 }}>
      {/* side wing */}
      <rect x="72" y="46" width="28" height="44" rx="2" fill="rgba(255,255,255,0.88)" />
      {win(78, 54)}{win(90, 54)}
      {win(78, 66)}{win(90, 66)}
      {win(78, 78)}{win(90, 78)}
      {/* main block */}
      <rect x="20" y="24" width="54" height="66" rx="2" fill="rgba(255,255,255,0.94)" />
      {win(28, 32)}{win(40, 32)}{win(52, 32)}{win(64, 32)}
      {win(28, 44)}{win(40, 44)}{win(52, 44)}{win(64, 44)}
      {win(28, 56)}{win(40, 56)}{win(52, 56)}{win(64, 56)}
      {/* entrance canopy + door */}
      <rect x="34" y="72" width="26" height="4" rx="1" fill={bg} />
      <rect x="39" y="76" width="16" height="14" rx="1" fill={bg} />
      {/* medical cross badge */}
      <g transform="translate(47,8)">
        <circle cx="0" cy="0" r="9" fill="#e05a5a" />
        <rect x="-1.6" y="-5.5" width="3.2" height="11" fill="#fff" />
        <rect x="-5.5" y="-1.6" width="11" height="3.2" fill="#fff" />
      </g>
      {/* ground line */}
      <rect x="14" y="90" width="92" height="2.5" rx="1.25" fill="rgba(255,255,255,0.35)" />
    </svg>
  );
}

/* Renders the hospital photo if we have one, otherwise an illustrated
   building graphic with the hospital's name — used in the grid card,
   list row, and modal so all three stay visually consistent. */
function ProjectVisual({ p, className, style }) {
  if (p.img) {
    return <img className={className} style={style} src={p.img} alt={p.title} />;
  }
  return (
    <div
      className={className}
      style={{
        ...style,
       
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 8,
        padding: "10px 12px",
        textAlign: "center",
      }}
    >
      <HospitalBuildingIcon />
      <span style={{  fontSize: 12, fontWeight: 700, color: "rgba(255,255,255,0.92)", lineHeight: 1.3 }}>
        {p.title}
      </span>
    </div>
  );
}

export default function Projects() {
  const navigate = useNavigate();
  const [activeType, setActiveType] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const [view,       setView]       = useState("grid");
  const [selected,   setSelected]   = useState(null);
  const [visible,    setVisible]    = useState(PAGE_SIZE);
  const [showConsultation, setShowConsultation] = useState(false);

  const openConsultation = () => setShowConsultation(true);
  const closeConsultation = () => setShowConsultation(false);

  useEffect(() => {
    document.body.style.overflow = (showConsultation || selected) ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showConsultation, selected]);

  const filtered = ALL_PROJECTS.filter(p => {
    if (activeType !== "All" && p.type !== activeType) return false;
    if (activeCity !== "All" && p.city !== activeCity) return false;
    return true;
  });

  useEffect(() => {
    setVisible(PAGE_SIZE);
  }, [activeType, activeCity]);

  const shown = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  const mapsLink = (address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  const mapsUrlFor = (p) => p.mapsUrl || mapsLink(p.address);

  return (
    <>
    <SEO/>
    <div style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", background:"#F6F7FC", color:"#343F86", minHeight:"100vh", overflowX:"hidden" }}>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin:0; padding:0; }
        img { display: block; }

        /* Hero */
        .hp-hero {
          position:relative; height:460px; overflow:hidden;
          display:flex; align-items:center; justify-content:center; text-align:center;
        }
        .hp-hero-bg {
  position:absolute; inset:0;
  background: linear-gradient(135deg, #343F86 0%, #262E63 50%, #343F86 100%);
}
        .hp-hero-inner { position:relative; z-index:1; padding:0 24px; max-width:800px; }
        .hp-hero-pill {
          display:inline-flex; align-items:center; gap:7px;
          background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15);
          border-radius:20px; padding:6px 16px; margin-bottom:22px;
        }
        .hp-hero-pill span { font-size:11px; font-weight:700; color:rgba(255,255,255,0.65); letter-spacing:2px; text-transform:uppercase; }
        .hp-hero h1 {
         
          font-size:clamp(30px,5.5vw,30px); font-weight:700;
          color:#fff; line-height:1.1; margin-bottom:14px;
        }
        .hp-hero p { font-size:15px; color:rgba(255,255,255,0.60); line-height:1.8; margin-bottom:32px; }
        .hp-hero-stats { display:flex; gap:40px; justify-content:center; flex-wrap:wrap; }
        .hp-hero-stat-num { font-size:28px; font-weight:700; color:#fff; line-height:1; }
        .hp-hero-stat-lbl { font-size:10px; color:rgba(255,255,255,0.40); letter-spacing:1.5px; text-transform:uppercase; margin-top:4px; }

        /* Filter bar */
        .hp-filterbar {
          background:#fff; border-bottom:1px solid #E1E3EE;
          position:sticky; top:106px; z-index:90;
          box-shadow:0 2px 12px rgba(0,0,0,0.04);
        }
        .hp-filterbar-inner {
          max-width:1280px; margin:0 auto; padding:0 24px;
          display:flex; align-items:center; gap:12px;
          height:56px; flex-wrap:nowrap; overflow-x:auto;
        }
        .hp-filter-label { font-size:11px; font-weight:700; color:#7FD0DA; letter-spacing:1.5px; text-transform:uppercase; flex-shrink:0; }
        .hp-view-btns { margin-left:auto; display:flex; gap:4px; flex-shrink:0; }
        .hp-view-btn {
          width:34px; height:34px; border:1.5px solid #E1E3EE;
          background:#fff; font-size:15px; cursor:pointer; border-radius:7px;
          display:flex; align-items:center; justify-content:center; transition:all 0.18s;
        }
        .hp-view-btn.active { background:#343F86; border-color:#343F86; color:#fff; }

        /* Body */
        .hp-body { max-width:1280px; margin:0 auto; padding:44px 24px 80px; }
        .hp-count { font-size:13.5px; color:#8A8F9C; margin-bottom:28px; }
        .hp-count strong { color:#343F86; }

        /* Grid */
        .hp-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; }

        /* Flip card */
        .hp-card-flip {
          background:transparent;
          perspective:1400px;
          border-radius:18px;
          height:330px;
        }
        .hp-card-flip-inner {
          position:relative; width:100%; height:100%;
          transition:transform 0.6s cubic-bezier(0.22,1,0.36,1);
          transform-style:preserve-3d;
        }
        .hp-card-flip:hover .hp-card-flip-inner { transform:rotateY(180deg); }
        .hp-card-face {
          position:absolute; inset:0; width:100%; height:100%;
          border-radius:18px; overflow:hidden;
          backface-visibility:hidden; -webkit-backface-visibility:hidden;
          border:2px solid #E1E3EE;
          transition:border-color 0.22s, box-shadow 0.22s, transform 0.22s;
          display:flex; flex-direction:column;
        }
        .hp-card-flip:hover .hp-card-face.hp-card-front {
          border-color:#343F86; transform:translateY(-5px); box-shadow:0 20px 52px rgba(0,0,0,0.11);
        }
        .hp-card-back {
          transform:rotateY(180deg);
          background:#343F86;
          color:#fff;
          padding:26px 24px;
          justify-content:space-between;
        }
        .hp-card-back-label { font-size:10px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:rgba(255,255,255,0.45); margin-bottom:10px; }
        .hp-card-back-title { font-size:17px; font-weight:700; margin-bottom:14px; line-height:1.3; }
        .hp-card-back-address { font-size:13.5px; line-height:1.8; color:rgba(255,255,255,0.75); margin-bottom:20px; }
        .hp-card-back-map {
          display:flex; align-items:center; justify-content:center; gap:8px;
          background:#fff; color:#343F86; border:none; border-radius:10px;
          padding:12px 0; font-size:12.5px; font-weight:700;
          cursor:pointer; text-decoration:none; transition:all 0.2s;
        }
        .hp-card-back-map:hover { background:#E1E3EE; }

        /* Card content (front) */
        .hp-card-img-wrap { position:relative; flex-shrink:0; }
        .hp-card-img { width:100%; height:250px; background:#ECEEF6; display:block; object-fit:cover; object-position:center; }
        .hp-card-body { padding:16px 18px 18px; flex:1; display:flex; flex-direction:column; background:#fff; overflow:hidden; }
        .hp-card-type {
          display:inline-flex; align-items:center; gap:5px;
          background:#343F86; color:#fff;
          font-size:10px; font-weight:700; letter-spacing:0.5px;
          padding:3px 10px; border-radius:5px; margin-bottom:8px;
          width:fit-content; flex-shrink:0;
        }
        .hp-card-title {
         font-size:14.5px; font-weight:700; color:#343F86;
          margin-bottom:6px; line-height:1.3;
          display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical;
          overflow:hidden; min-height:38px; flex-shrink:0;
        }
        .hp-card-meta { font-size:12px; color:#8A8F9C; flex-shrink:0; }
        .hp-delivered-badge {
          font-size:10px; font-weight:700; color:#1a6e45;
          background:#e8f5ee; padding:3px 9px; border-radius:5px;
          display:inline-block; margin-top:8px; flex-shrink:0;
        }

        /* List view */
        .hp-list-item {
          background:#fff; border:2px solid #E1E3EE; border-radius:14px;
          display:flex; gap:0; cursor:pointer; overflow:hidden; margin-bottom:12px;
          transition:all 0.22s;
        }
        .hp-list-item:hover { border-color:#343F86; box-shadow:0 8px 28px rgba(0,0,0,0.09); }
        .hp-list-img { width:150px; height:130px; object-fit:cover; object-position:center; background:#ECEEF6; display:block; flex-shrink:0; }
        .hp-list-body { padding:20px 24px; flex:1; display:flex; justify-content:space-between; align-items:center; gap:16px; flex-wrap:wrap; }
        .hp-list-title { font-size:15px; font-weight:700; color:#343F86; margin-bottom:5px; }
        .hp-list-meta { font-size:13px; color:#8A8F9C; margin-bottom:8px; }

        /* Load more */
        .hp-loadmore-wrap { display:flex; justify-content:center; margin-top:36px; }
        .hp-loadmore-btn {
          background:#fff; color:#343F86; border:2px solid #343F86; border-radius:11px;
          padding:13px 36px; font-size:13px; font-weight:700;
          cursor:pointer; transition:all 0.2s;
        }
        .hp-loadmore-btn:hover { background:#343F86; color:#fff; }

        /* Empty */
        .hp-empty { text-align:center; padding:80px 0; }

        /* Project Modal */
        .hp-modal-overlay {
          position:fixed; inset:0; background:rgba(0,0,0,0.72); z-index:9999;
          display:flex; align-items:center; justify-content:center; padding:20px;
        }
        .hp-modal {
          background:#fff; max-width:640px; width:100%;
          max-height:88vh; overflow-y:auto; border-radius:20px; overflow-x:hidden;
        }
        .hp-modal-img { width:100%; height:220px; object-fit:cover; object-position:center; background:#ECEEF6; display:block; }
        .hp-modal-body { padding:32px; }
        .hp-modal-type {
          display:inline-flex; align-items:center; gap:6px;
          background:#343F86; color:#fff;
          font-size:11px; font-weight:700; letter-spacing:0.5px;
          padding:4px 12px; border-radius:6px; margin-bottom:14px;
        }
        .hp-modal-title { font-size:24px; font-weight:700; color:#343F86; margin-bottom:8px; line-height:1.3; }
        .hp-modal-meta { font-size:14px; color:#8A8F9C; margin-bottom:20px; line-height:1.6; }
        .hp-modal-meta a { color:#343F86; font-weight:600; text-decoration:none; border-bottom: 1px solid #343F86; }
        .hp-modal-btns { display:flex; gap:12px; }
        .hp-btn-primary {
          flex:1; background:#343F86; color:#fff; border:none; border-radius:10px;
          padding:13px 0; font-size:13px; font-weight:700;
          cursor:pointer; transition:all 0.2s;
        }
        .hp-btn-primary:hover { background:#262E63; }
        .hp-btn-outline {
          flex:1; background:#fff; color:#343F86; border:2px solid #343F86; border-radius:10px;
          padding:13px 0;  font-size:13px; font-weight:700;
          cursor:pointer; transition:all 0.2s;
        }
        .hp-btn-outline:hover { background:#ECEEF6; }

        /* CTA strip */
        .hp-cta { background: linear-gradient(135deg,#343F86 0%,#262E63 50%,#343F86 100%); padding:72px 24px; text-align:center; position:relative; overflow:hidden; }
        .hp-cta-dots { position:absolute; inset:0; opacity:0.04; background-image:radial-gradient(circle at 50% 50%,#fff 1px,transparent 1px); background-size:36px 36px; }
        .hp-cta h2 {  font-size:clamp(26px,4vw,40px); font-weight:700; color:#fff; margin-bottom:12px; position:relative; }
        .hp-cta p { font-size:15px; color:rgba(255,255,255,0.52); max-width:440px; margin:0 auto 36px; line-height:1.75; position:relative; }
        .hp-cta-btn {
          background:#fff; color:#2F8A98; border:none; border-radius:11px;
          padding:16px 44px;  font-size:14px; font-weight:700;
          cursor:pointer; text-transform:uppercase; letter-spacing:0.5px; transition:all 0.25s; position:relative;
        }
        .hp-cta-btn:hover { transform:translateY(-3px); box-shadow:0 16px 44px rgba(255,255,255,0.18); }

        /* Consultation modal */
        .hp-consult-overlay {
          position: fixed; inset: 0; z-index: 2000;
          background: rgba(0,0,0,0.65);
          backdrop-filter: blur(5px);
          display: flex; align-items: center; justify-content: center;
          padding: 1rem;
        }
        .hp-consult-inner {
          position: relative; width: 100%; max-width: 680px;
          max-height: 90vh; overflow-y: auto; border-radius: 18px;
        }
        .hp-consult-close {
          position: absolute; top: 14px; right: 16px; z-index: 10;
          background: #262E63; border: none; color: #fff;
          width: 32px; height: 32px; border-radius: 50%;
          font-size: 20px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          line-height: 1;
        }
        .hp-consult-close:hover { background: #3A4060; }

        /* Dropdown selects */
        .hp-select-wrap { position: relative; display: flex; align-items: center; }
        .hp-select {
          appearance: none; -webkit-appearance: none;
          padding: 8px 36px 8px 14px; border-radius: 9px;
          border: 1.5px solid #E1E3EE;
           font-size: 13px; font-weight: 600; color: #262E63;
          background: #fff; cursor: pointer; outline: none;
          transition: border-color 0.2s; min-width: 170px;
        }
        .hp-select:hover, .hp-select:focus { border-color: #343F86; }
        .hp-select-arrow { position: absolute; right: 12px; pointer-events: none; color: #8A8F9C; font-size: 11px; }

        /* ══════════════════════════════════════
           RESPONSIVE
        ══════════════════════════════════════ */
        @media (max-width:900px) {
          .hp-grid { grid-template-columns:repeat(2,1fr); gap:16px; }
        }

        @media (max-width:768px) {
          .hp-hero { height:auto; padding:96px 20px 40px; }
          .hp-hero-pill { margin-bottom:16px; padding:5px 12px; }
          .hp-hero-pill span { font-size:10px; }
          .hp-hero h1 { font-size:30px; margin-bottom:12px; }
          .hp-hero p { font-size:13.5px; margin-bottom:24px; line-height:1.7; }
          .hp-hero-stats { gap:24px; }
          .hp-hero-stat-num { font-size:22px; }
          .hp-hero-stat-lbl { font-size:9px; }

          .hp-filterbar { top:60px; }
          .hp-filterbar-inner { padding:0 16px; gap:8px; }
          .hp-select { min-width:130px; font-size:12px; padding:7px 30px 7px 12px; }

          .hp-body { padding:28px 16px 56px; }
          .hp-count { font-size:12.5px; margin-bottom:18px; }

          .hp-card-flip { height:360px; }
          .hp-card-img { height:130px; }
          .hp-card-body { padding:14px 14px 14px; }
          .hp-card-type { font-size:9px; padding:3px 8px; }
          .hp-card-title { font-size:13.5px; min-height:35px; }
          .hp-card-meta { font-size:11px; }
          .hp-delivered-badge { font-size:9px; }
          .hp-card-back { padding:18px 16px; }
          .hp-card-back-title { font-size:15px; margin-bottom:10px; }
          .hp-card-back-address { font-size:12.5px; margin-bottom:14px; }

          .hp-list-img { width:90px; height:90px; }
          .hp-list-body { padding:12px 14px; gap:10px; }
          .hp-list-title { font-size:13.5px; }
          .hp-list-meta { font-size:12px; }

          .hp-modal-overlay { padding:0; align-items:flex-end; }
          .hp-modal { max-width:100%; width:100%; max-height:92vh; border-radius:20px 20px 0 0; }
          .hp-modal-img { height:180px; }
          .hp-modal-body { padding:22px 18px 26px; }
          .hp-modal-type { font-size:10px; padding:3px 10px; margin-bottom:10px; }
          .hp-modal-title { font-size:19px; margin-bottom:6px; }
          .hp-modal-meta { font-size:12.5px; margin-bottom:16px; }
          .hp-modal-btns { flex-direction:column; }
          .hp-btn-primary, .hp-btn-outline { flex:none; padding:12px 0; font-size:12.5px; }

          .hp-cta { padding:48px 20px; }
          .hp-cta p { font-size:13.5px; margin-bottom:26px; }
          .hp-cta-btn { padding:14px 32px; font-size:12.5px; width:100%; }

          .hp-consult-inner { max-width:100%; border-radius:18px; }
        }

        @media (max-width:560px) {
          .hp-grid { grid-template-columns:1fr; }
          .hp-card-flip { height:auto; }
          .hp-card-flip-inner { min-height:290px; }
        }

        @media (max-width:420px) {
          .hp-hero h1 { font-size:26px; }
          .hp-select { min-width:110px; }
          .hp-list-item { flex-direction:column; }
          .hp-list-img { width:100%; height:140px; }
          .hp-list-body { flex-direction:column; align-items:flex-start; }
        }
      `}</style>

      {/* ── HERO ── */}
      <div className="hp-hero" style={{ paddingTop: 106 }}>
        <div className="hp-hero-bg" />
        <div className="hp-hero-inner">
          <div className="hp-hero-pill">
            <span style={{ width:6, height:6, borderRadius:"50%", background:"#CDD1E0", display:"inline-block" }} />
            <span>Hospital Infrastructure Portfolio</span>
          </div>
          <h1>Our Delivered<br/>Hospital Projects</h1>
          <p>
            Explore PR Hospital Designers' portfolio of completed hospital infrastructure projects
            across Telangana and Andhra Pradesh.
          </p>
          <div className="hp-hero-stats">
            {[["42+","Hospitals Delivered"],[String(CITIES.length - 1),"Cities Covered"],["NABH","Compliant"],["24/7","Support"]].map(([v,l]) => (
              <div key={l}>
                <div className="hp-hero-stat-num">{v}</div>
                <div className="hp-hero-stat-lbl">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="hp-filterbar">
        <div className="hp-filterbar-inner">
          <span className="hp-filter-label">Filter:</span>

          {/* Type Dropdown */}
          <div className="hp-select-wrap">
            <select className="hp-select" value={activeType} onChange={e => setActiveType(e.target.value)}>
              <option value="All">🏥 All Types</option>
              {TYPES.filter(t => t !== "All").map(t => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
            <span className="hp-select-arrow">▾</span>
          </div>

          {/* City Dropdown */}
          <div className="hp-select-wrap">
            <select className="hp-select" value={activeCity} onChange={e => setActiveCity(e.target.value)}>
              {CITIES.map(c => (
                <option key={c} value={c}>{c === "All" ? "📍 All Cities" : c}</option>
              ))}
            </select>
            <span className="hp-select-arrow">▾</span>
          </div>

          <div className="hp-view-btns">
            <button className={`hp-view-btn${view === "grid" ? " active" : ""}`} onClick={() => setView("grid")}>⊞</button>
            <button className={`hp-view-btn${view === "list" ? " active" : ""}`} onClick={() => setView("list")}>≡</button>
          </div>
        </div>
      </div>

      {/* ── BODY ── */}
      <div className="hp-body">
        <div className="hp-count">
          Showing <strong>{shown.length}</strong> of <strong>{filtered.length}</strong> hospital{filtered.length !== 1 ? "s" : ""}
          {activeType !== "All" && <> · <strong>{activeType}</strong></>}
          {activeCity !== "All" && <> · <strong>{activeCity}</strong></>}
        </div>

        {filtered.length === 0 ? (
          <div className="hp-empty">
            <div style={{ fontSize:52, marginBottom:16 }}>🔍</div>
            <div style={{ fontSize:20, fontWeight:700, color:"#343F86", marginBottom:8 }}>No hospitals found</div>
            <div style={{ fontSize:14, color:"#8A8F9C", marginBottom:24 }}>Try a different type or city</div>
            <button
              style={{ background:"#343F86", color:"#fff", border:"none", borderRadius:10, padding:"11px 28px", fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize:13, fontWeight:700, cursor:"pointer" }}
              onClick={() => { setActiveType("All"); setActiveCity("All"); }}
            >
              Clear Filters
            </button>
          </div>
        ) : view === "grid" ? (
          <>
            <div className="hp-grid">
              {shown.map(p => (
                <div key={p.id} className="hp-card-flip" onClick={() => setSelected(p)}>
                  <div className="hp-card-flip-inner">

                    {/* FRONT */}
                    <div className="hp-card-face hp-card-front">
                      <div className="hp-card-img-wrap">
                        <ProjectVisual p={p} className="hp-card-img" />
                      </div>
                      <div className="hp-card-body">
                        <div className="hp-card-type">{p.type}</div>
                        <div className="hp-card-title">{p.title}</div>
                        <div className="hp-card-meta">📍 {p.location}</div>
                        <span className="hp-delivered-badge">✓ Completed</span>
                      </div>
                    </div>

                    {/* BACK */}
                    <div className="hp-card-face hp-card-back">
                      <div>
                        <div className="hp-card-back-label">Project Location</div>
                        <div className="hp-card-back-title">{p.title}</div>
                        <div className="hp-card-back-address">📍 {p.location}</div>
                      </div>
                      <a
                        className="hp-card-back-map"
                        href={mapsUrlFor(p)}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        🗺️ Open in Google Maps
                      </a>
                    </div>

                  </div>
                </div>
              ))}
            </div>
            {hasMore && (
              <div className="hp-loadmore-wrap">
                <button className="hp-loadmore-btn" onClick={() => setVisible(v => v + PAGE_SIZE)}>
                  Load More Hospitals
                </button>
              </div>
            )}
          </>
        ) : (
          <>
            <div>
              {shown.map(p => (
                <div key={p.id} className="hp-list-item" onClick={() => setSelected(p)}>
                  <ProjectVisual p={p} className="hp-list-img" />
                  <div className="hp-list-body">
                    <div>
                      <div style={{ display:"inline-flex", alignItems:"center", gap:5, background:"#343F86", color:"#fff", fontSize:10, fontWeight:700, padding:"2px 9px", borderRadius:5, marginBottom:8 }}>
                        {p.type}
                      </div>
                      <div className="hp-list-title">{p.title}</div>
                      <div className="hp-list-meta">📍 {p.location}</div>
                      <span className="hp-delivered-badge">✓ Completed</span>
                    </div>
                    <a
                      className="hp-btn-outline"
                      style={{ flex: "0 0 auto", padding: "10px 20px", textDecoration: "none", display: "inline-block" }}
                      href={mapsUrlFor(p)}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      🗺️ Map
                    </a>
                  </div>
                </div>
              ))}
            </div>
            {hasMore && (
              <div className="hp-loadmore-wrap">
                <button className="hp-loadmore-btn" onClick={() => setVisible(v => v + PAGE_SIZE)}>
                  Load More Hospitals
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* ── PROJECT MODAL ── */}
      {selected && (
        <div className="hp-modal-overlay" onClick={() => setSelected(null)}>
          <div className="hp-modal" onClick={e => e.stopPropagation()}>
            <ProjectVisual p={selected} className="hp-modal-img" />
            <div className="hp-modal-body">
              <div className="hp-modal-type">{selected.type}</div>
              <div className="hp-modal-title">{selected.title}</div>
              <div className="hp-modal-meta">
                📍 {selected.location} &nbsp;·&nbsp;
                <a href={mapsUrlFor(selected)} target="_blank" rel="noopener noreferrer">
                  Open in Google Maps ↗
                </a>
              </div>
              <div className="hp-modal-btns">
                <button className="hp-btn-primary" onClick={() => { setSelected(null); openConsultation(); }}>
                  🏥 Get a Similar Project
                </button>
                <button className="hp-btn-outline" onClick={() => setSelected(null)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── CTA STRIP ── */}
      <div className="hp-cta">
        <div className="hp-cta-dots" />
        <h2>Ready to build your hospital?</h2>
        <p>From NABH consultation to full infrastructure delivery — PR Hospital Designers handles it all.</p>
        <button className="hp-cta-btn" onClick={openConsultation}>
          Book Free Hospital Consultation
        </button>
      </div>

      {/* ── CONSULTATION MODAL ── */}
      {showConsultation && (
        <div
          className="hp-consult-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) closeConsultation(); }}
        >
          <div className="hp-consult-inner">
            <button className="hp-consult-close" onClick={closeConsultation} aria-label="Close consultation form">
              ×
            </button>
            <Consultation />
          </div>
        </div>
      )}

    </div>
    </>
  );
}